<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 5L0 0.838288L0.805714 0L4 3.31748L7.19429 0L8 0.838288L4 5Z" fill="#080828"/>
</svg>
